import translations from './translations'

translations.add('es', {
    closePaymentMethods: 'cerrar métodos de pago',
    otherPaymentMethods: 'otros métodos de pago'
})
